export enum FetchPriority {
  LOW = 'low',
  HIGH = 'high',
  AUTO = 'auto',
}
